import React from 'react'
import Fade from 'react-reveal/Fade';
import { BiLogoLinkedin } from "react-icons/bi";
import vinay from '../Image/vinay.jpg'
import srijan from '../Image/srijan.jpg'
import pooja from '../Image/pooja.jpg'
import suman from '../Image/suman.jpg'
import bhawna from '../Image/bhawna.jpg'
import gaurav from '../Image/gaurav.jpeg'
import yash from '../Image/yash.jpeg'
import manoran from '../Image/manoran.jpeg'

function Company_staff() {
  return (
    <div>

    {/* ------------------------------Mobile View--------------------------- */}
    <div className='bg-white d-sm-block d-md-none '>
    <div className='container'>
        <div className='text-center'>
        <span className=" display-5 staff_component_text ">Meet Our Brilliant Team</span>
            <p className="pb-3 pt-3 mobile_staff_component_text_p">Our success is powered by a diverse team of talented individuals, each contributing unique expertise and passion to transform education through technology. Meet our exceptional team driving positive change.</p>
        </div>
        <div className='row px-2'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow rounded py-4 '>
                        <div className='row'>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={suman} className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Suman</h5>
                            <h6 className="mb-3">CEO & Founder</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/suman-kumar-4811841b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app' target='_blank' ><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-8'>
                            <div>
                            <span class="fas fa-quote-left"></span>
                            </div>
                            <div className='text-start  pt-3'>
                            <p className="Mobile_about_card_text">Meet Suman Kumar, the passionate and driven CEO and Founder of Internselite. With his unwavering commitment to revolutionizing education, Suman brings a wealth of expertise and leadership to our team. Leveraging his extensive background in computer science and his deep understanding of the education landscape, Suman founded Internselite with a vision to bridge the gap between traditional learning and the demands of the digital age. Through innovative teaching methodologies and advanced technology, Suman is dedicated to empowering students with the essential skills and knowledge needed to thrive in today's rapidly evolving world. Under his guidance, Internselite strives to reshape the education experience and prepare students for success in the modern workforce.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right"></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </div>
            <div className='container mt-5'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow rounded py-4 '>
                        <div className='row'>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={bhawna} className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Bhawna Singla</h5>
                            <h6 className="mb-3">Founder & MD</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/bhawna-singla-447a25166?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-8'>
                        <div>
                            <span class="fas fa-quote-left"></span>
                            </div>
                            <div className='text-start  pt-3'>
                            <p className="Mobile_about_card_text">Meet Bhawna Singla, the passionate and driven Founder and Managing Director of Internselite. Armed with a Master of Business Administration (MBA) background, Bhawna combines her business acumen with a visionary approach to education. Her leadership at Internselite aims to transform the educational landscape by integrating business principles into the learning experience. With a commitment to preparing students for the dynamic challenges of the modern business world, Bhawna focuses on fostering a curriculum that not only imparts essential skills but also instills a strategic mindset. Under her guidance, Internselite strives to empower students with the knowledge and expertise required to excel in the competitive business environment. Bhawna Singla's dedication to merging business education with technological advancements positions Internselite as a pioneering force in shaping the business leaders of tomorrow. </p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right"></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </div>
            {/* <div className='container mt-5'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow rounded py-4 '>
                        <div className='row'>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={aditya}className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Aditya Shivsharmil</h5>
                            <h6 className="mb-3">Vice President</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/aditya-shivsharmil-268a9b152?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-8'>
                        <div>
                            <span class="fas fa-quote-left"></span>
                            </div>
                            <div className='text-start  pt-3'>
                            <p className="Mobile_about_card_text">Meet Aditya Shivsharmil, the Vice President at Internselite, bringing a robust background in technology and sales to the leadership team. Aditya holds a dual degree in B.Tech and M.Tech, showcasing his technical prowess and academic excellence. With a wealth of experience as the Assistant Vice President (AVP) of Sales, Aditya has honed his skills in driving business growth and building strong client relationships. His strategic approach to sales aligns with Internselite's vision of connecting education and technology. Aditya is instrumental in expanding Internselite's reach and ensuring that the innovative educational methodologies developed by the company reach a wider audience. 
                            His dual expertise in technology and sales positions Aditya as a key player in the dynamic environment of Internselite, contributing to the company's mission of preparing students for success in the digital age. With Aditya's leadership, Internselite continues to thrive and make a significant impact in the education and technology sectors.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right"></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </div> */}
            <div className='container mt-5'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow rounded py-4 '>
                        <div className='row'>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={vinay} className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Vinay Singla</h5>
                            <h6 className="mb-3">Admin & Head of Operations</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/vinay-45b101180?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-8'>
                        <div>
                            <span class="fas fa-quote-left"></span>
                            </div>
                            <div className='text-start  pt-3'>
                            <p className="Mobile_about_card_text">Meet Vinay Singla, the dedicated Admin and Head of Operations at Internselite. With a keen eye for detail and a passion for efficient organizational management, Vinay plays a crucial role in ensuring the smooth functioning of operations within the company.
                            Drawing from his experience and expertise in administration, Vinay brings a structured and systematic approach to Internselite's daily operations. His responsibilities include overseeing logistics, managing resources, and maintaining a productive and collaborative work environment for the entire team.Vinay's commitment cellence is reflected in his meticulous attention to operational details, contributing to the overall success of Internselite. His role is pivotal in supporting the company's mission to revolutionize education through innovative methodologies and advanced technology.
                            As Admin and Head of Operations, Vinay Singla plays a key role in the cohesive functioning of Internselite, ensuring that the organization operates seamlessly to deliver a high-quality educational experience to students.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right"></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
                <div className='row mt-5'>
                    {/* <div className='col-6'>
                        <div className='shadow rounded py-4'>
                        <div className='d-flex justify-content-center'>
                        <img src={ashutos} className="rounded-circle shadow-1-strong staff_card_img"/>
                        </div>
                        <div className='text-center pt-3'>
                        <h6 className="mb-2">Ashutosh Kumar</h6>
                        <h6 className="mb-2">Senior Manager</h6>
                        </div>
                        <div className='text-center pt-3'>
                        <a href='https://www.linkedin.com/in/ashutosh-kumar-88a02013b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                        </div>
                        </div>
                    </div> */}
                    <div className='col-6'>
                        <div className='shadow rounded py-4'>
                        <div className='d-flex justify-content-center'>
                        <img src={'https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg?w=740&t=st=1714460001~exp=1714460601~hmac=3f1de8f2f7a6b162298fb5e2b5c423c55bc4d28584a989e96eed2472e96b2e7c'} className="rounded-circle shadow-1-strong staff_card_img"/>
                        </div>
                        <div className='text-center pt-3'>
                        <h6 className="mb-2">Manoranjan Sharma</h6>
                        <h6 className="mb-2">Senior Manager</h6>
                        </div>
                        <div className='text-center pt-3'>
                        <a href='https://www.linkedin.com/in/manoranjan-sharma-8a84b7176?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                        </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='shadow rounded py-4'>
                        <div className='d-flex justify-content-center'>
                        <img src={gaurav} className="rounded-circle shadow-1-strong staff_card_img"/>
                        </div>
                        <div className='text-center pt-3'>
                        <h6 className="mb-2">Gaurav</h6>
                        <h6 className="mb-2">Team Leader</h6>
                        </div>
                        <div className='text-center pt-3 px-1'>
                        <a href='https://www.linkedin.com/in/gaurav-kumar-16b825210?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                        </div>
                        </div>
                    </div>
                    <div className='col-6 mt-3'>
                        <div className='shadow rounded py-4'>
                        <div className='d-flex justify-content-center'>
                        <img src={srijan} className="rounded-circle shadow-1-strong staff_card_img"/>
                        </div>
                        <div className='text-center pt-3'>
                        <h6 className="mb-2">Srijan Shandilya</h6>
                        <h6 className="mb-2">HR & Recruiter Head</h6>
                        </div>
                        <div className='text-center pt-3'>
                        <a href='http://linkedin.com/in/srijan-shandilya' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                        </div>
                        </div>
                    </div>
                    <div className='col-6 mt-3'>
                        <div className='shadow rounded py-4'>
                        <div className='d-flex justify-content-center'>
                        <img src={pooja} className="rounded-circle shadow-1-strong staff_card_img"/>
                        </div>
                        <div className='text-center pt-3'>
                        <h6 className="mb-2">Pooja Choudhary</h6>
                        <h6 className="mb-2">HR</h6>
                        </div>
                        <div className='text-center pt-3'>
                        <a href='https://www.linkedin.com/in/pooja-chaudhary-37406922b' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                        </div>
                        </div>
                    </div>
                    <div className='col-12 mt-3'>
                        <div className='shadow rounded py-4'>
                        <div className='d-flex justify-content-center'>
                        <img src={yash} className="rounded-circle shadow-1-strong staff_card_img"/>
                        </div>
                        <div className='text-center pt-3'>
                        <h6 className="mb-2">Yash Kumar</h6>
                        <h6 className="mb-2">BDE</h6>
                        </div>
                        <div className='text-center pt-3'>
                        <a href='https://www.linkedin.com/in/yash-kumar-3967b527b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>

    {/* ----------------------------Desktop View-------------------------------- */}
    <div className=' d-none d-md-block mb-5 mt-5'>    
    <div className='container-fluid'>
        <div className='text-center'>
        <span className=" display-5 staff_component_text ">Meet Our Brilliant Team</span>
        <div className=' mx-5 px-5'>
        <p className="pt-3 pb-5 mb-md-5 pb-md-0 px-5">Our success is powered by a diverse team of talented individuals, each contributing unique expertise and passion to transform education through technology. Meet our exceptional team driving positive change.</p>
        </div>
        </div>
        <div className='row '>
            <Fade left className='container'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow rounded py-4 '>
                        <div className='row'>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={suman} className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Suman</h5>
                            <h6 className="mb-2">CEO & Founder</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/suman-kumar-4811841b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-8'>
                            <div>
                            <span class="fas fa-quote-left px-2"></span>
                            </div>
                            <div className='text-start  pt-3 px-2'>
                            <p className="">Meet Suman Kumar, the passionate and driven CEO and Founder of Internselite. With his unwavering commitment to revolutionizing education, Suman brings a wealth of expertise and leadership to our team. Leveraging his extensive background in computer science and his deep understanding of the education landscape, Suman founded Internselite with a vision to bridge the gap between traditional learning and the demands of the digital age. Through innovative teaching methodologies and advanced technology, Suman is dedicated to empowering students with the essential skills and knowledge needed to thrive in today's rapidly evolving world. Under his guidance, Internselite strives to reshape the education experience and prepare students for success in the modern workforce.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right px-3"></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </Fade>
            <Fade right className='container mt-5'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow py-4 rounded'>
                        <div className='row'>
                        <div className='col-md-8'>
                        <div>
                            <span class="fas fa-quote-left px-3"></span>
                            </div>
                            <div className='text-start  pt-3 px-3'>
                            <p className="">Meet Bhawna Singla, the passionate and driven Founder and Managing Director of Internselite. Armed with a Master of Business Administration (MBA) background, Bhawna combines her business acumen with a visionary approach to education. Her leadership at Internselite aims to transform the educational landscape by integrating business principles into the learning experience. With a commitment to preparing students for the dynamic challenges of the modern business world, Bhawna focuses on fostering a curriculum that not only imparts essential skills but also instills a strategic mindset. Under her guidance, Internselite strives to empower students with the knowledge and expertise required to excel in the competitive business environment. Bhawna Singla's dedication to merging business education with technological advancements positions Internselite as a pioneering force in shaping the business leaders of tomorrow.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right"></span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={bhawna}className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Bhawna Singla</h5>
                            <h6 className="mb-2">Founder & MD</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/bhawna-singla-447a25166?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </Fade>
            <Fade left className='container mt-5'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow rounded py-4 '>
                        <div className='row'>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                                <img src={vinay} className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Vinay Singla</h5>
                            <h6 className="mb-2">Admin & Head of Operations</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/vinay-45b101180?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'  target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-8'>
                        <div>
                            <span class="fas fa-quote-left px-2"></span>
                            </div>
                            <div className='text-start  pt-3 px-2'>
                            <p className="">Meet Vinay Singla, the dedicated Admin and Head of Operations at Internselite. With a keen eye for detail and a passion for efficient organizational management, Vinay plays a crucial role in ensuring the smooth functioning of operations within the company.
                            Drawing from his experience and expertise in administration, Vinay brings a structured and systematic approach to Internselite's daily operations. His responsibilities include overseeing logistics, managing resources, and maintaining a productive and collaborative work environment for the entire team.Vinay's commitment cellence is reflected in his meticulous attention to operational details, contributing to the overall success of Internselite. His role is pivotal in supporting the company's mission to revolutionize education through innovative methodologies and advanced technology.
                            As Admin and Head of Operations, Vinay Singla plays a key role in the cohesive functioning of Internselite, ensuring that the organization operates seamlessly to deliver a high-quality educational experience to students.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right px-2"></span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </Fade>
            {/* <Fade right className='container mt-5'>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-10 shadow py-4 rounded'>
                        <div className='row'>
                        <div className='col-md-8'>
                        <div>
                            <span class="fas fa-quote-left px-3"></span>
                            </div>
                            <div className='text-start  pt-3 px-3'>
                            <p className="">Meet Vinay Singla, the dedicated Admin and Head of Operations at Internselite. With a keen eye for detail and a passion for efficient organizational management, Vinay plays a crucial role in ensuring the smooth functioning of operations within the company.
                            Drawing from his experience and expertise in administration, Vinay brings a structured and systematic approach to Internselite's daily operations. His responsibilities include overseeing logistics, managing resources, and maintaining a productive and collaborative work environment for the entire team.Vinay's commitment cellence is reflected in his meticulous attention to operational details, contributing to the overall success of Internselite. His role is pivotal in supporting the company's mission to revolutionize education through innovative methodologies and advanced technology.
                            As Admin and Head of Operations, Vinay Singla plays a key role in the cohesive functioning of Internselite, ensuring that the organization operates seamlessly to deliver a high-quality educational experience to students.</p>
                            </div>
                            <div className='text-end'>
                            <span class="fas fa-quote-right"></span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='d-flex justify-content-center'>
                            <img src={vinay} className="rounded-circle shadow-1-strong staff_card_img"/>
                            </div>
                            <div className='text-center pt-3'>
                            <h5 className="mb-2">Vinay Singla</h5>
                            <h6 className="mb-2">Admin & Head of Operations</h6>
                            <div className='text-center pt-2'>
                            <a href='https://www.linkedin.com/in/vinay-45b101180?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'  target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
            </Fade> */}
        </div>
        <Fade top>
        <div className='row mt-5 px-5'>
            <div className='col-md-1'></div>
            {/* <div className='col-md-2'>
                <div className='shadow rounded py-4'>
                <div className='d-flex justify-content-center'>
                <img src={ashutos} className="rounded-circle shadow-1-strong staff_card_img"/>
                </div>
                <div className='text-center pt-3'>
                <h5 className="mb-2">Ashutosh Kumar</h5>
                <h6 className="mb-2">Senior Manager</h6>
                </div>
                <div className='text-center pt-3'>
                <a href='https://www.linkedin.com/in/ashutosh-kumar-88a02013b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
            </div> */}
            <div className='col-md-2'>
                <div className='shadow rounded py-4'>
                <div className='d-flex justify-content-center'>
                <img src={'https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg?w=740&t=st=1714460001~exp=1714460601~hmac=3f1de8f2f7a6b162298fb5e2b5c423c55bc4d28584a989e96eed2472e96b2e7c'} className="rounded-circle shadow-1-strong staff_card_img"/>
                </div>
                <div className='text-center pt-3'>
                <h5 className="mb-2">Manoranjan Sharma</h5>
                <h6 className="mb-2">Senior Manager</h6>
                </div>
                <div className='text-center pt-3'>
                <a href='https://www.linkedin.com/in/manoranjan-sharma-8a84b7176?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
            </div>
            <div className='col-md-2'>
                <div className='shadow rounded py-4'>
                <div className='d-flex justify-content-center'>
                <img src={gaurav} className="rounded-circle shadow-1-strong staff_card_img"/>
                </div>
                <div className='text-center pt-3'>
                <h5 className="mb-2">Gaurav</h5>
                <h6 className="mb-2">Team Leader</h6>
                </div>
                <div className='text-center pt-3'>
                <a href='https://www.linkedin.com/in/gaurav-kumar-16b825210?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
            </div>
            
            <div className='col-md-2'>
                <div className='shadow rounded py-4'>
                <div className='d-flex justify-content-center'>
                <img src={srijan} className="rounded-circle shadow-1-strong staff_card_img"/>
                </div>
                <div className='text-center pt-3'>
                <h5 className="mb-2">Srijan Shandilya</h5>
                <h6 className="mb-2">HR & Recruiter Head</h6>
                </div>
                <div className='text-center pt-3'>
                <a href='http://linkedin.com/in/srijan-shandilya' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
            </div>
            <div className='col-md-2'>
                <div className='shadow rounded py-4'>
                <div className='d-flex justify-content-center'>
                <img src={pooja} className="rounded-circle shadow-1-strong staff_card_img"/>
                </div>
                <div className='text-center pt-3'>
                <h5 className="mb-2">Pooja Choudhary</h5>
                <h6 className="mb-2">HR</h6>
                </div>
                <div className='text-center pt-3'>
                <a href='https://www.linkedin.com/in/pooja-chaudhary-37406922b' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
            </div>
            <div className='col-md-2'>
                <div className='shadow rounded py-4'>
                <div className='d-flex justify-content-center'>
                <img src={yash} className="rounded-circle shadow-1-strong staff_card_img"/>
                </div>
                <div className='text-center pt-3'>
                <h5 className="mb-2">Yash Kumar</h5>
                <h6 className="mb-2">BDE</h6>
                </div>
                <div className='text-center pt-3'>
                <a href='https://www.linkedin.com/in/yash-kumar-3967b527b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        </Fade>
    </div>
    </div>
     </div>
  )
}

export default Company_staff
